import { InstructionType } from 'types/InstructionType'

export const InstructionTypeSortingOrder = [
  InstructionType.REFERENCE,
  InstructionType.COMMENTS,
  InstructionType.ORGANIZATION,
  InstructionType.BILLING,
  InstructionType.BILLING_PRIMARY,
]